import React from 'react'

export default function ContractorProgress({ }) {
  return <div>ContractorProgress</div>
}